export default __webpack_public_path__ + "static/media/freeAddress.3dbca522.svg";